import { axiosInstance } from "Services/Api/base-api";
import {
  SaveMobileAppDeviceSettingsApiResultType,
} from "Types/api-types";
import { SaveMobileAppDeviceSettingsModelType } from "Types/device-types";

export default class DeviceApi {
  saveMobileAppDeviceSettings = async (
    deviceSettings: SaveMobileAppDeviceSettingsModelType
  ): Promise<SaveMobileAppDeviceSettingsApiResultType> => {
    return await axiosInstance
      .post("/Device/SaveMobileAppDeviceSettings", JSON.stringify(deviceSettings))
      .then((response) => response.data);
  };
}
